import { PaneArea } from '../../types/shared'
import Rectangle, { IRectangleAttrs } from '../canvas/rectangle'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IRectangleAttrs
type PartialAttrs = Partial<Attrs>

class RectangleCreator extends Rectangle<Attrs> {
  isCreator = true
  mouseDowns = 1

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = this.attrs.x2 = startArea.x
    this.attrs.y1 = this.attrs.y2 = startArea.y
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown(area: PaneArea) {
    this.mouseDowns++
    if (this.mouseDowns > 1) {
      this.attrs.x2 = area.x
      this.attrs.y2 = area.y
      this.release()
      this.replaceMyself(Rectangle.fromObject<Rectangle>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    this.attrs.x2 = area.x
    this.attrs.y2 = area.y
    return this.trigger('change')
  }
}

export default RectangleCreator
